// extracted by mini-css-extract-plugin
export default {"overlay":"PortalOverlay_overlay__K6J9t","hide":"PortalOverlay_hide__vpvxb"};